import { API_TTasks, convertTaskForTable, TTask_Table } from "@/models/tasks_services";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { TO_DO_TASK_STATUS, COMPLETED_TASK_STATUS } from "@/constants/tasks";
import { SMNps } from "@/store";

@Module({ name: "MTasksServices", namespaced: true })
export default class MTasksServices extends VuexModule {
  loading = false;

  employerTasksToDo: TTask_Table[] = [];
  candidateTasksToDo: TTask_Table[] = [];

  employerTasksArchived: TTask_Table[] = [];
  candidateTasksArchived: TTask_Table[] = [];

  @Mutation
  setLoading(value: boolean) {
    this.loading = value;
  }

  @Mutation
  setEmployerTasksToDo(data: API_TTasks) {
    if (!data.employer_tasks) return;

    this.employerTasksToDo = data.employer_tasks.map((a) => convertTaskForTable(a));
  }

  @Mutation
  setCandidateTasksToDo(data: API_TTasks) {
    if (!data.candidate_tasks) return;

    this.candidateTasksToDo = data.candidate_tasks.map((a) => convertTaskForTable(a));
  }

  @Mutation
  setMainTasksArchived(data: API_TTasks) {
    if (!data.employer_tasks) return;

    this.employerTasksArchived = data.employer_tasks
      .filter((a) => a.status === COMPLETED_TASK_STATUS)
      .map((a) => convertTaskForTable(a));
  }

  @Mutation
  setSideTasksArchived(data: API_TTasks) {
    if (!data.candidate_tasks) return;

    this.candidateTasksArchived = data.candidate_tasks
      .filter((a) => a.status === COMPLETED_TASK_STATUS)
      .map((a) => convertTaskForTable(a));
  }

  @Action
  async archiveTableTask(id: number | string) {
    await axios.get(API_ROUTES.ARCHIVE_TASK(id));
  }

  @Action
  async getTableTasksToDo(caseId: number) {
    try {
      this.setLoading(true);

      const { data } = await axios.get<API_TTasks>(
        API_ROUTES.CASE_TASKS(caseId, TO_DO_TASK_STATUS)
      );

      if (!data) return;

      if (!data.employer_tasks?.length) SMNps.checkNps();

      this.setEmployerTasksToDo(data);
      this.setCandidateTasksToDo(data);
    } finally {
      this.setLoading(false);
    }
  }

  @Action
  async getTableTasksArchived(caseId: number) {
    try {
      this.setLoading(true);

      const { data } = await axios.get<API_TTasks>(
        API_ROUTES.CASE_TASKS(caseId, COMPLETED_TASK_STATUS)
      );

      if (!data) return;

      this.setMainTasksArchived(data);
      this.setSideTasksArchived(data);
    } finally {
      this.setLoading(false);
    }
  }
}
